<template>
  <div class="article-page page">
    <BreadcrumbsComponent @back.prevent :links="links" />
    <div class="article-page__title-container">
      <h1 class="article-page__title">{{ article?.title }}</h1>
    </div>
    <div class="article-page__container">
      <div class="article-page__content">
        <div class="article-page__img">
          <ImgComponent :head_img="article?.head_img" quality="99" />
        </div>
        <div v-if="article?.text" class="article-page__description">
          <EditorJSComponent :text="getText" />
        </div>
        <div v-if="products" class="article-page__products" ref="list">
          <ProductCardComponent v-for="(item, i) in products.data" :key="i" :data="item" />
        </div>
        <span v-else>Товары отсутствуют</span>
        <PaginationComponent
          v-if="showPagination"
          :page="page"
          :total="Math.ceil(products.paginatorInfo.total / first)"
          @change="paginate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ARTICLE_PAGE from "@/graphql/pages/ArticlePage.graphql";
import EditorJSComponent from "components/EditorJSComponent.vue";
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";

export default {
  name: "ArticlePage",
  data() {
    return {
      page: 1,
      paginateLoading: false,
    };
  },
  async asyncData({ apollo, store, route }) {
    await apollo.defaultClient
      .query({
        query: ARTICLE_PAGE,
        variables: {
          id: parseInt(route.params.id),
          first: store.state.isMobile ? 12 : 16,
          page: 1,
        },
      })
      .then(({ data }) => {
        store.state.article_page.article = data.article;
        store.state.article_page.products = data.products_paginate;
        store.state.categories = data.categories;
        store.state.marketplace = data.marketplace;
        if (data.exchange_rates) store.state.exchange_rates = data.exchange_rates;
      });
  },
  computed: {
    getText() {
      return JSON.parse(this.$store.state.article_page.article?.text);
    },
    links() {
      return [{ title: "Блог", route: { name: "blog" } }, { title: this.article?.title }];
    },
    article() {
      return this.$store.state.article_page.article;
    },
    products() {
      return this.$store.state.article_page.products;
    },
    showArticles() {
      return this.products && this.products.data && this.products.data.length;
    },
    showPagination() {
      return this.showArticles && Math.ceil(this.products.paginatorInfo.total / this.first) > 1;
    },
    first() {
      return this.$store.state.isMobile ? 12 : 16;
    },
  },
  methods: {
    load() {
      this.$apollo.provider.defaultClient
        .query({
          query: ARTICLE_PAGE,
          variables: {
            id: parseInt(this.$route.params.id),
            first: this.first,
            page: this.page,
          },
        })
        .then(({ data }) => {
          this.$store.state.article_page.article = data.article;
          this.$store.state.article_page.products = data.products_paginate;
        })
        .finally(() => {
          this.paginateLoading = false;
        });
    },
    async paginate(page) {
      if (!this.paginateLoading) {
        this.page = page;
        this.paginateLoading = true;
        await this.load();
        this.scrollUp();
      }
    },
    scrollUp() {
      if (window.scrollY > this.$refs.list.offsetTop) {
        window.scrollTo({ top: this.$refs.list.offsetTop });
      }
    },
  },
  components: {
    BreadcrumbsComponent,
    EditorJSComponent,
  },
  metaInfo() {
    return {
      title: this.$store.state.article_page.article.meta_title ?? this.article?.title,
      meta: [
        {
          vmid: "keywords",
          name: "keywords",
          content: this.$store.state.article_page.article.meta_keywords ?? '',
        },
        {
          vmid: "description",
          name: "description",
          content: this.$store.state.article_page.article.meta_description ?? '',
        },
        {
          vmid: "og:title",
          name: "og:title",
          content: this.$store.state.article_page.article.meta_title ?? this.article?.title,
        },
        {
          vmid: "og:description",
          name: "og:description",
          content: this.$store.state.article_page.article.meta_description ?? '',
        },
      ],
    }
  },
};
</script>

<style lang="stylus">
.article-page {
  width 100%
  display grid
  grid-gap 32px
  padding-top 32px
  padding-bottom 48px
  +below(420px) {
    grid-gap 16px
  }

  &__title {
    max-width var(--main_width)
    width 100%
    font-weight: normal;
    font-size: 2.25em;
    line-height: 50px;
    display: flex;
    align-items: center;
    color: var(--body-color);
    margin 0 auto

    &-container {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 15px;
    }
  }

  &__container {
    display: flex;
    justify-content: center;
    padding: 0 15px;
  }

  &__content {
    display grid
    grid-gap 32px
    width 100%
    max-width var(--main_width)
  }

  &__img {
    width 100%
    height 290px

    img {
      width 100%
      height 100%
      object-fit cover
      object-position center
      border-radius var(--main_radius)
    }
  }

  &__description {
    display flex
    width 100%
    max-width var(--small_width)
    margin 0 auto
  }

	&__products {
		display grid
		grid-template-columns repeat(4, 1fr)
		grid-gap 24px
		+below(990px) {
			grid-template-columns repeat(3, 1fr)
			grid-gap 16px
		}
		+below(720px) {
			grid-template-columns repeat(2, 1fr)
			grid-gap 8px
		}
		+below(380px) {
			grid-template-columns 1fr
		}
	}
}
</style>
